
























import { Component, Vue } from 'vue-property-decorator';
import { Mutation, State } from 'vuex-class';
import Mixin from '../mixin';
import Auth from '@aws-amplify/auth';
import API from '@aws-amplify/api';

@Component({})
export default class Home extends Mixin {
  @Mutation private loggedIn!: (user: any) => void;
  @Mutation private signIn!: (user: any) => void;
  @State private cognito!: any;
  private password: string = '';
  private confirmation: string = '';

  private mounted() {
    (this.$el.querySelector('#password') as HTMLInputElement).focus();
  }

  private async update(event: any) {
    if (event.target.disabled) {
      return;
    }
    event.target.disabled = true;
    try {
      if (this.password.length < 1) {
        this.msg('パスワードは空にできません');
        return;
      }
      if (this.password !== this.confirmation) {
        this.msg('確認用のパスワードが異なります');
        return;
      }
      await Auth.completeNewPassword(this.cognito, this.password, this.cognito.challengeParam.requredAttributes);
      this.msg('パスワードを更新しました');
      setTimeout(() => {
        this.$router.push('/');
      }, 1000);
      const userInfo = await API.post('api', '/user', {
        headers: {Authorization: (await Auth.currentSession() as any).idToken.jwtToken },
      });
      this.signIn(userInfo);
    } catch (ex) {
      if (ex === 'Password cannot be empty') {
        this.msg('パスワードは空にできません');
      } else {
        this.msg(ex);
      }
    } finally {
      event.target.disabled = false;
    }
  }
}
